module.exports = __webpack_public_path__ + "static/three_explain.78d087d4.png";